import React from 'react';
import {Button, message, Modal} from "antd";
import {uuid} from "../../../../utils";
import {Scrollbars} from "react-custom-scrollbars";
import NormalModal from "./normalModal";
import TaskMessage from "../../../Interview/components/viewBtn/TaskMessage";


class ViewTasksModal extends NormalModal {
    version = 0;
    id = uuid();
    formData = {};

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            activityOption: {},//流程配置文件
            loadKey: uuid(),
            id: ""
        }
    }

    cleanData = () => {
        this.state.id = "";
        this.state.activityOption = {};
        this.formData = {};
        this.otherData = {};
    };
    otherData = {};

    show(taskId) {
        this.state.taskId = taskId;
        this.setState({visible: true});
    };

    hide = () => {
        this.setState({visible: false});
    };

    render() {
        return (
            <Modal
                visible={this.state.visible}
                title={this.props.title||'任务信息'}
                onOk={() => {
                    this.props.callBack && this.props.callBack()
                }}
                onCancel={() => {
                    this.setState({visible: false})
                }}
                maskClosable={false}
                footer={<Button type={"primary"} onClick={this.hide}>关闭</Button>}
                width={800}
                key={this.state.loadKey}
            >
                {/*<Scrollbars autoHide autoHeight*/}
                {/*            autoHeightMax={document.body.clientHeight > 400 ? document.body.clientHeight - 300 : document.body.clientHeight}>*/}
                    <div>
                        <TaskMessage id={this.state.taskId}/>
                    </div>
                {/*</Scrollbars>*/}
            </Modal>
        );
    }
}

export default ViewTasksModal;
